import { render, staticRenderFns } from "./MarketplaceSKULayout.vue?vue&type=template&id=4804a648&scoped=true&"
import script from "./MarketplaceSKULayout.vue?vue&type=script&lang=js&"
export * from "./MarketplaceSKULayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4804a648",
  null
  
)

export default component.exports